import {FC} from 'react'

import {theme} from '@/theme/theme'

type PulseIconProps = {
  size?: number
  circleColor?: string
  pulseColor?: string
}

export const PulseIcon: FC<PulseIconProps> = ({
  size = 24,
  circleColor = 'transparent',
  pulseColor = theme.palette.primary.main,
}) => (
  <>
    <div className="pulse" />

    <style jsx>{`
      .pulse {
        position: relative;
        top: 0;
        left: 0;
        width: ${size}px;
        height: ${size}px;
        border-radius: 50%;
        background-color: ${circleColor};
        animation: pulse 1200ms infinite;
      }
      @keyframes pulse {
        0% {
          box-shadow: 0 0 0 0 ${pulseColor};
        }
        70% {
          box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
        }
        100% {
          box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
        }
      }
    `}</style>
  </>
)
